module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/asana_sculpt-55385ce1abfb1c030e1b5c8b42225668.png";